module.exports = "<div class=\"spinner-content\">\n  <mat-spinner></mat-spinner>\n</div>\n"